import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { Col, Row } from 'reactstrap';

//Components
import TabelaListagemFichas from '../../../../components/TabelaListagemFichas/TabelaListagemFichas';
import TabelaQuestao from './TabelaQuestao';

//Helpers


export default function FichaFormularioPGRSContainer({ formulario }) {
    const headersTabelaBlocos = [
        { value: "Identificação", objectValue: "identificacao", align: "left" },
        { value: "Descrição", objectValue: "descricao", align: "left" }
    ]

    return (
        <div style={{ color: "#666" }}>
            <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ color: "#fff" }}>
                <span><FontAwesomeIcon icon={faPencilAlt} className="me-2" /> Blocos</span>
            </h5>
            <Row>
                <TabelaListagemFichas
                    paging={false}
                    headers={headersTabelaBlocos}
                    items={formulario?.tbFormularioPGRSBlocos ?? []}
                />
            </Row>


            {formulario?.tbFormularioPGRSBlocos && formulario?.tbFormularioPGRSBlocos.map((bloco, index) => (
                <Row key={index}>
                    <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ color: "#fff" }}>
                        <span><FontAwesomeIcon icon={faPencilAlt} className="me-2" /> Questões do Bloco - {bloco.identificacao}</span>
                    </h5>
                    <TabelaQuestao
                        ficha={true}
                        paging={false}
                        items={bloco.tbFormularioPGRSBlocoQuestoes}
                    />
                </Row>
            ))
            }

            <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ color: "#fff" }}>
                <span><FontAwesomeIcon icon={faFileAlt} className="me-2" /> Documentos</span>
            </h5>
            <Row>
                {formulario?.tbFormularioPGRSDocumentos?.map((documento, index) => (
                    <Col lg={3} key={index} className="mb-3">
                        <div className="card shadow h-100 d-flex flex-column">
                            <div className="card-body d-flex flex-column align-items-center text-center">
                                <div className="mb-3">
                                    <label htmlFor={`file-upload-${index}`} className="d-flex justify-content-center">
                                        <FontAwesomeIcon icon={faFileAlt} className="text-secondary" size="4x" />
                                    </label>
                                </div>

                                <div style={{ maxWidth: '100%', wordBreak: 'break-word' }}>
                                    <strong>{documento.identificacao || "Documento"}</strong>
                                </div>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>


            <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ color: "#fff" }}>
                <span><FontAwesomeIcon icon={faFileAlt} className="me-2" /> Modalidades</span>
            </h5>
            <Row>
                <TabelaListagemFichas
                    paging={false}
                    headers={[
                        { value: "Descrição", objectValue: "descricao", align: "left" }
                    ]}
                    items={formulario?.tbFormularioPGRSModalidades ?? []}
                />
            </Row>
        </div >
    )

}